import { Flex } from 'antd';
import React, { useContext } from 'react';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { useChatSettings } from '@guuru/chat-web';
import BottomMenu from '../BottomMenu';
import ExternalNavigationContext from '../context/ExternalNavigationContext';
import GlobalStyle from '../styles/GlobalStyle';

const excludedPaths = ['/form', '/transcript'];

const Layout = styled(Flex)`
  height: 100%;
`;

const BaseLayout = function () {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const waitReady = useContext(ExternalNavigationContext);

  const { data: { chatSettings: { chatWidgetFont } = {} } = {} } =
    useChatSettings();

  if (waitReady) return null;

  const showBottomMenuInPath = !excludedPaths.some((path) =>
    pathname.includes(path),
  );
  const spaces = searchParams.get('spaces')?.split(',') ?? [];
  const hasMultipleSpaces = spaces.length > 1;

  return (
    <Layout vertical>
      <GlobalStyle font={chatWidgetFont} transparent={false} />
      <div className="container">
        <Outlet />
      </div>
      {showBottomMenuInPath && hasMultipleSpaces && (
        <BottomMenu spaces={spaces} />
      )}
    </Layout>
  );
};

export default BaseLayout;
